"use client"

import { Check, Palette } from "lucide-react"
import { Repo } from "../types"

type Props = {
  repo: Repo
  onSelect: (repo: Repo) => void
  isSelected?: boolean
  colors?: string[] // Array of color codes passed as props
  disabled: boolean
}

const RepositorySelect = ({ repo, onSelect, isSelected = false, colors, disabled }: Props) => {
  const hasColors = colors && colors.length > 0

  return (
    <div
    role="button"
    aria-disabled={disabled}
    className={`
      cursor-pointer transition-all duration-300 transform hover:scale-105 w-full
      ${disabled ? 'opacity-50 pointer-events-none' : ''}
    `}
    onClick={() => !disabled && onSelect(repo)}
    tabIndex={disabled ? -1 : 0}
    >
      <div
        className={`
        relative flex flex-col h-28 w-full max-w-sm rounded-xl overflow-hidden shadow-md
        ${isSelected ? "ring-2 ring-[#FE6434] shadow-lg" : "hover:shadow-lg"}
      `}
      >
        {/* Top colorful section */}
        {hasColors ? (
          <div className="flex h-28 w-full">
            {colors.slice(0, 3).map((color, index) => (
              <div key={index} className="flex-1 h-full" style={{ backgroundColor: color }} />
            ))}
          </div>
        ) : (
          <div className="flex h-32 w-full items-center justify-center bg-gray-100">
            <div className="text-center text-gray-400 flex flex-col items-center">
              <Palette className="h-6 w-6 mb-1" />
              <span className="text-xs">Add info to repo</span>
            </div>
          </div>
        )}

        {/* Bottom content section */}
        <div className="flex items-center px-4 py-3 bg-white flex-1">
          <h3 className="font-medium text-gray-800 truncate flex-1">{repo.name}</h3>
        </div>
      </div>
    </div>
  )
}

export default RepositorySelect
